import { DayOfWeekType } from 'lib/daysOfWeek'
import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { eachDayOfInterval, format, isSameDay } from 'date-fns'
import { isHolidayOfStore, parseToDate } from 'lib/helper'
import { setClosedDatesAction } from 'reducks/calendar/actions'
import { SpecialHolidayType } from 'types/calendar'

const fetchClosedDates = (
  start: Date,
  end: Date,
  holidays: DayOfWeekType[],
  specialHolidays: SpecialHolidayType[],
  storeRef: FirebaseDocRefType
) => {
  return async (dispatch: Dispatch<Action>) => {
    // 定休日の取得
    const datesOfMonth: Date[] = eachDayOfInterval({ start: start, end: end })
    let closedDates = datesOfMonth.filter((date) => isHolidayOfStore(date, holidays, specialHolidays))

    // 臨時休業日の取得
    const storeCalendars = await storeRef
      .collection('store_calendars')
      .orderBy('date', 'asc')
      .startAt(format(start, 'yyyyMMdd'))
      .get()

    for (let i = 0; i < storeCalendars.docs.length; i = (i + 1) | 0) {
      const storeCalendar = storeCalendars.docs[i].data()
      // 臨時休業日を追加
      if (storeCalendar.status === 'close') {
        closedDates.push(parseToDate(storeCalendar.date))
      }
      // 臨時営業日を削除
      if (storeCalendar.status === 'open') {
        closedDates = closedDates.filter((closedDate) => !isSameDay(closedDate, parseToDate(storeCalendar.date)))
      }
    }

    dispatch(setClosedDatesAction(closedDates))
  }
}

export default fetchClosedDates
